<template>
  <div v-if="groups!=null">
    <div class="group" v-for="(group, key) in groups" :key="key">
        <div>DisplayName: {{group.displayName}}</div>
        <router-link :to="'/case/'+group.id"><button>Pogledaj predmet</button></router-link>
    </div>
  </div>
  <!-- <div>Ovo su grupe</div> -->
</template>

<script>
import graph from '@/services/graph'
import share from '@/apiCallers/sharepoint'
export default {
  name: 'GroupList',

  props: {
    accessToken: {
      type: String,
      required: true,
      default: null
    }
  },

  data() {
    return {
      groups : null
    }
  },

  watch: {
    accessToken : function()
    {
        if(this.accessToken){
            this.getGroups();
        }
    }
  },
  methods:
  {
    getGroups()
    {
      share.getAll(this.accessToken).then((response)=>{
        this.groups = response.data.value
      })
    }
  }
}
</script>
<style lang="css" scoped>
.group{
  border: 1px solid black;
  width: 450px;
  padding: 1vw;
  margin:auto;



}
</style>
